import { DomainId } from './domains.js';
import { Maybe, Timestamp } from '../data.js';
import { apply, maybe, parseURL } from '../util.js';

export interface Menu extends MenuEntry {
	id: string;
	key: string;
	domain: DomainId;
	special?: string;
	deleted?: boolean;
	created: Timestamp;
	updated: Timestamp;
}

export type MenuEntryTag = 'pop-out' | 'log-out' | 'cart' | 'hidden' | 'skip-sidebar' | 'skip-sidebar-for-user' | 'skip-header' | 'account' | 'vendor' | 'stores' | 'user' | 'mobile-only' | 'mega';

export interface MenuEntry {
	title?: string;
	link?: string;
	image?: string;
	submenu?: Maybe<string>;
	icon?: any; // preact types break ts-json-schema-generator, lol.
	entries?: Maybe<MenuEntries>;
	tags?: Maybe<MenuEntryTag[]>;
}

export type MenuEntries = MenuEntry[];

export function findActiveMenu(entries: MenuEntries, pathname: string, query: Maybe<Record<string, string>>): Maybe<MenuEntries> {
	const split = pathname.split('/').filter(p => p.length);
	let found: Maybe<MenuEntries> = null;
	for (let l = split.length; !found && l; l--) {
		const match = `/${split.slice(0, l).join('/')}`;
		const walk = (entries: MenuEntries, path: MenuEntries) => {
			for (const me of entries) {
				
				maybe(me.entries, s => walk(s, [...path, me]));
				
				const parsed = maybe(me.link, parseURL);
				if (
					parsed?.pathname
					&& parsed.pathname.indexOf(match) == 0
					&& parsed.pathname.length <= match.length + 1
					&& apply(parsed.query, q => (!q || Object.keys(q).every(k => q[k] == query?.[k])))
				) {
					if (!found || me.link!.length > found[found.length - 1]!.link!.length) {
						found = [...path, me];
					}
				}
				
			}
		};
		walk(entries, []);
	}
	return found;
}

export function findParentMenu(entries: MenuEntries, child: MenuEntry) {
	let found: Maybe<MenuEntry> = null;
	const walk = (entries: MenuEntries, parent: Maybe<MenuEntry>) => {
		for (const me of entries) {
			if (found) break;
			if (me == child) return found = parent;
			if (me.entries) walk(me.entries, me);
		}
	};
	walk(entries, null);
	return found;
}
